import './App.css';
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React, { useState, Suspense } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { appRoutes } from './routes';
import Header from './components/Header';

export default function App() {
  const [username, setUsername] = useState();
  const [isLogin, setIsLogin] = useState(false);

  const location = useLocation();

  return (
    <>
      <Header isLogin={isLogin} setIsLogin={setIsLogin} />
      <SwitchTransition component={null}>
        <CSSTransition key={location.pathname} classNames="fade" timeout={300} unmountOnExit>
          <Suspense fallback={() => <h2>Loading...</h2>}>
            <Routes location={location}>
              {appRoutes.map((route) => {
                if (route.requiresAuth && !isLogin) {
                  return (
                    <Route
                      key={route.path}
                      exact
                      path={route.path}
                      element={<Navigate replace to={'/login'} />} />
                  )
                } else {
                  return (
                    <Route
                      key={route.path}
                      exact
                      path={route.path}
                      element={<route.component
                        setUsername={setUsername}
                        setIsLogin={setIsLogin}
                        username={username}
                      />} />
                  )
                }
              })}
              {/* <Route exact path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/users' element={<Users />} />
            <Route path='/users/user/:username' element={<UserProfile />} />
            <Route path='/search' element={<SearchUser />} />
            <Route path='/login' element={<Login setUsername={setUsername} setIsLogin={setIsLogin} />} />
            <Route
              path='/authprofile'
              element={isLogin ?
                <AuthProfile username={username} /> : <Navigate replace to={"/login"} />} />
            <Route path='*' element={<NotFound />} /> */}
            </Routes>
          </Suspense>
        </CSSTransition>
      </SwitchTransition>
    </>
  );
}